import Pagination from '../Pagination';
const DataTable = ({
  columns,
  items = [],
  rowKey,
  onRowClick,
  page,
  limit,
  total,
  onPageChange,
  loading = false,
  wide = false,
}) => {
  return (
    <>
      <div
        className={`panel table-wrap full-table${wide ? ' wide-table' : ''}${onRowClick ? ' clickable-table' : ''}`}
      >
        <table>
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.key}>{column.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr
                key={rowKey(item, index)}
                onClick={onRowClick ? () => onRowClick(item) : undefined}
              >
                {columns.map((column) => (
                  <td key={column.key}>{column.render(item)}</td>
                ))}
              </tr>
            ))}
            {!items.length && (
              <tr className="empty-row">
                <td colSpan={columns.length}>אין נתונים להצגה</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Pagination
        page={page}
        limit={limit}
        total={total}
        onPageChange={onPageChange}
        loading={loading}
      />
    </>
  );
};
export default DataTable;
